import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import {
  deleteCalendar,
  selectCalendars,
} from "../../../store/slices/projectSlice";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function Calendars() {
  const params = useParams();
  const calendars = useSelector(selectCalendars);
  const dispatch = useDispatch();

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-start">
        <h5 className="card-title">Calendars</h5>
        <HelpButton helpKey="calendars" />
        <div className="flex-grow-1" />
        <Link
          to={`/library/logic/builder/${params.projectID}/calendar/create_new`}
          className="btn btn-outline-primary btn-sm border-0"
        >
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </div>
      <div className="card-body p-0">
        {calendars.length > 0 ? (
          <ul className="list-group list-group-flush">
            {calendars.map((calendar) => (
              <li
                key={calendar.UUID}
                className="list-group-item p-2 d-flex justify-content-between align-items-center"
              >
                <Link
                  to={`/library/logic/builder/${params.projectID}/calendar/${calendar.UUID}`}
                >
                  <span>{calendar.Label || calendar.UUID.slice(0, 5)}</span>
                </Link>

                <UsedInBadge
                  arg={calendar}
                  alt={
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm border-0"
                      onClick={() => {
                        dispatch(deleteCalendar(calendar.UUID));
                        toast.success("Calendar deleted");
                      }}
                      title="Delete calendar"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                  }
                />
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center m-1">No Calendars</div>
        )}
      </div>
    </div>
  );
}
